import Vue from 'vue';
import Clipboard from 'v-clipboard';
import '@/plugins/sentry';
import Main from '@/Main.vue';
import router from '@/plugins/router';
import store from '@/plugins/store';
import 'jquery/src/jquery';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'lightbox2/dist/js/lightbox';
import 'lightbox2/dist/css/lightbox.css';
import 'vue-date-pick/dist/vueDatePick.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
import '@/globalComponents';
import '@/assets/styles/default.styl';
import '@/assets/styles/main.styl';
import '@/filters/global_filters';

Vue.config.productionTip = false;
Vue.use(Clipboard);

Window.vue = new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit('USERS_INIT');
  },
  render: (h) => h(Main),
}).$mount('#app');
